<template>
  <v-row>
    <v-col :cols="$vuetify.display.mobile ? 12 : 4">

      <v-btn-toggle variant="outlined" color="primary" class="d-flex"
        mandatory v-model="displayingConfig">
        <v-btn class="flex-fill" value="size">
          大きさ
        </v-btn>
        <v-btn class="flex-fill" value="position">
          機器配置
        </v-btn>
      </v-btn-toggle>

      <v-card class="mt-3" v-if="displayingConfig === 'size'">
        <v-card-text class="pa-5">
          <p class="mb-1">横方向の大きさ</p>
          <v-number-input
            variant="outlined"
            density="comfortable"
            hide-details
            control-variant="split"
            readonly
            :min="1"
            v-model="horizontalSize">
          </v-number-input>

          <p class="mb-1 mt-5">縦方向の大きさ</p>
          <v-number-input
            variant="outlined"
            density="comfortable"
            hide-details
            control-variant="split"
            readonly
            :min="1"
            v-model="verticalSize"
          ></v-number-input>
        </v-card-text>
      </v-card>

      <v-card class="mt-3" v-if="displayingConfig === 'position'">
        <v-card-text>
          <v-list mandatory color="primary" v-bind:max-height="$vuetify.display.mobile ? '172px' : ''"
            v-model:selected="selectedDevice">
            <v-list-item value="親">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>親機</v-list-item-title>
            </v-list-item>
            <v-list-item value="①">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機1</v-list-item-title>
            </v-list-item>
            <v-list-item value="②">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機2</v-list-item-title>
            </v-list-item>
            <v-list-item value="③">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機3</v-list-item-title>
            </v-list-item>
            <v-list-item value="④">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機4</v-list-item-title>
            </v-list-item>
            <v-list-item value="⑤">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機5</v-list-item-title>
            </v-list-item>
            <v-list-item value="⑥">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機6</v-list-item-title>
            </v-list-item>
            <v-list-item value="⑦">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機7</v-list-item-title>
            </v-list-item>
            <v-list-item value="⑧">
              <template v-slot:prepend>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <v-list-item-title>子機8</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>

    </v-col>

    <v-col :cols="$vuetify.display.mobile ? 12 : 8">

      <v-card :elevation="0">
        <v-card-text class="pt-6 overflow-x-auto d-flex"><!-- d-flexによってFirefoxでスクロール時に余白が消えるのを回避 -->

          <table class="mx-auto" style="border-collapse: collapse;"
            v-bind:style="{ 'min-width': (horizontalSize * 40).toString() + 'px' }">
            <tbody>
              <tr style="height: 40px;" :key="verticalIndex" v-for="verticalIndex of verticalSize">
                <td :key="verticalIndex.toString() + '-' + horizontalIndex.toString()" v-for="horizontalIndex of horizontalSize"
                  class="text-center" v-bind:class="{ 'bg-blue-lighten-5': houseMap[verticalIndex][horizontalIndex] != null }"
                  style="width: 40px; border: 1px solid #9E9E9E; cursor: pointer; user-select: none;"
                  v-on:click="cellClicked(verticalIndex, horizontalIndex);">
                  {{ houseMap[verticalIndex][horizontalIndex] }}
                </td>
              </tr>
            </tbody>
          </table>

        </v-card-text>

        <v-card-actions class="py-4 px-5 d-flex justify-end">
          <v-btn variant="tonal" color="primary" v-on:click="redirect">
            確認する
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-col>
  </v-row>
</template>

<script>
import { ref, onMounted, watch } from 'vue';

import rison from 'rison';

import config from '@/config.js';

export default {
  name: 'HouseMapView',

  setup() {

    const displayingConfig = ref('size');

    const horizontalSize = ref(18);
    const verticalSize = ref(6);

    const selectedDevice = ref(['親']);

    const houseMap = ref({});

    if (location.hash.split('#').length > 2) {

      const houseMapParams = rison.decode_object(location.hash.split('#')[2]);

      horizontalSize.value = Math.ceil(houseMapParams.xMax);
      verticalSize.value = Math.ceil(houseMapParams.yMax);

      for (let rowIndex = 1; rowIndex <= verticalSize.value; rowIndex++) {
        houseMap.value[rowIndex] = {};
      }

      const userID = window.sessionStorage.getItem("userID");
      for (let i = 0; i < houseMapParams.d.length; i++) {

        let label = '';
        Object.keys(config.users[userID].boxes).forEach((key) => {
          if (config.users[userID].boxes[key].boxID === houseMapParams.d[i].id) {
            label = key;
          }
        });

        if (label === '') {
          continue;
        }

        houseMap.value[(verticalSize.value - houseMapParams.d[i].y)][(houseMapParams.d[i].x + 1)] = label;
      }

    } else {

      for (let rowIndex = 1; rowIndex <= verticalSize.value; rowIndex++) {
        houseMap.value[rowIndex] = {};
      }

    }

    onMounted(() => {

      watch(horizontalSize, (newValue, oldValue) => {

        if (newValue < oldValue) {

          for (let rowIndex = 1; rowIndex <= verticalSize.value; rowIndex++) {
            delete houseMap.value[rowIndex][oldValue];
          }

        }

      });

      watch(verticalSize, (newValue, oldValue) => {

        if (newValue < oldValue) {
          delete houseMap.value[oldValue]
        } else {
          houseMap.value[newValue] = {};
        }

      });

    });

    const cellClicked = (rowIndex, colIndex) => {

      if (houseMap.value[rowIndex][colIndex] != null) {
        if (houseMap.value[rowIndex][colIndex] === selectedDevice.value[0]) {
          delete houseMap.value[rowIndex][colIndex];
          return;
        }
      }


      for (let row = 1; row <= verticalSize.value; row++) {
        for (let col = 1; col <= horizontalSize.value; col++) {

          if (houseMap.value[row][col] === selectedDevice.value[0]) {
            delete houseMap.value[row][col];
          }

        }
      }

      houseMap.value[rowIndex][colIndex] = selectedDevice.value[0];

    };

    const redirect = () => {

      var houseMapParams = {

        userID: window.sessionStorage.getItem("userID"),

        xMin: -0.5,
        xMax: horizontalSize.value - 1 + 0.5,
        yMin: -0.5,
        yMax: verticalSize.value - 1 + 0.5,

        d: []

      };

      for (let row = 1; row <= verticalSize.value; row++) {
        for (let col = 1; col <= horizontalSize.value; col++) {
          if (houseMap.value[row][col] != null) {

            const id = config.users[houseMapParams.userID].boxes[houseMap.value[row][col]].boxID;

            houseMapParams.d.push({
              id: id,
              x: col - 1,
              y: verticalSize.value - row
            });

          }
        }
      }

      window.location.href = '#/measurement-result#' + rison.encode_object(houseMapParams);

    };

    return {
      displayingConfig,

      horizontalSize,
      verticalSize,

      selectedDevice,

      houseMap,

      cellClicked,

      redirect
    }

  }
}
</script>

